import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { Util } from '@/repository/repositories/utils';
import {
  FetchProjectBasic,
  FindOneProjectQuery,
  FindOneProjectResponse,
  CreateProjectDto,
  UpdateProjectParams,
  CreateProjectTaskAttributeValueOption,
  UpdateProjectCustomAttributesParam,
  UpdateProjectTaskAttributeValueOptionsParam,
  UpdateTaskAttributeValueOptionsQuery,
  FindProjectTaskAttributeValueOptionsResponse,
  CreateTaskAttributeValueOptionResponse,
  CreateProjectResponse,
  FindProjectsResponse,
} from '@/@types/Project';
import { UpdateModeQueryDto } from '@/@types/Common';

export class ProjectsRepository {
  private readonly requestBasePath = 'v1/projects';
  private readonly axios = new TheoryApiAxiosBase();
  private readonly util = new Util();

  async createProject(createProjectDto: CreateProjectDto) {
    try {
      return (await this.axios.post<CreateProjectResponse>(this.requestBasePath, createProjectDto)).data;
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async fetchOneProject(projectId: number) {
    const path = `${this.requestBasePath}/${projectId}`;
    try {
      const response = await this.axios.get<FetchProjectBasic>(path, { params: { 'get-mode': 'basic' } });
      return response.data.results;
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async fetchOneProjectDetail(projectId: number) {
    const path = `${this.requestBasePath}/${projectId}`;
    try {
      const responce = await this.axios.get<FindOneProjectResponse>(path, { params: { 'get-mode': 'all' } });
      return responce.data.results;
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async findOneProject (
    projectId: number,
    query: FindOneProjectQuery,
  ) {
    const path = `${this.requestBasePath}/${projectId}`;
    return (await this.axios.get<FindOneProjectResponse>(
      path,
      { params: query },
    )).data;
  }

  async updateProjectPart({ projectId, data }: UpdateProjectParams) {
    const path = `${this.requestBasePath}/${projectId}`
    try {
      await this.axios.patch<void>(path, data, { params: { 'update-mode': 'part' } });
    } catch {
      // TODO: エラーハンドリング
    }
  }

  /** プロジェクトカスタム属性更新 */
  async updateProjectCustomAttributes(
    projectId: number,
    param: UpdateProjectCustomAttributesParam,
    query: UpdateModeQueryDto,
  ) {
    const endPoint = this.endPointCreator(
      projectId,
      'custom-attributes',
    );
    await this.axios.patch(endPoint, param, { params: query });
  }

  async deleteTaskAttributeValueOption(projectId: number, taskAttributeValueOptionId: number) {
    const path = `${this.requestBasePath}/${projectId}/task-attributes/${taskAttributeValueOptionId}`
    try {
      await this.axios.delete<void>(path);
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async createTaskAttributeValueOption(projectId: number, data: CreateProjectTaskAttributeValueOption) {
    const path = `${this.requestBasePath}/${projectId}/task-attributes`
    try {
      const response = await this.axios.post<CreateTaskAttributeValueOptionResponse>(path, data);
      return response.data;
    } catch {
      // TODO: エラーハンドリング
    }
  }

  /** 課題属性値選択項目一覧取得 */
  async findProjectTaskAttributeValueOptions(
    projectId: number,
  ) {
    const endPoint = this.endPointCreator(
      projectId,
      'task-attributes',
    );
    return (await this.axios.get<FindProjectTaskAttributeValueOptionsResponse>(
      endPoint,
    )).data;
  }

  private endPointCreator(...paths: (string | number)[]) {
    return this.util.endPointCreator(this.requestBasePath, ...paths);
  }

  /** 課題属性値選択項目更新 */
  async updateProjectTaskAttributeValueOptions(
    projectId: number,
    param: UpdateProjectTaskAttributeValueOptionsParam,
    query: UpdateTaskAttributeValueOptionsQuery,
  ) {
    const endPoint = this.endPointCreator(
      projectId,
      'task-attributes',
    );
    await this.axios.patch(endPoint, param, { params: query });
  }

  /** プロジェクト一覧取得API */
  async getAllProjects(organizationId: number) {
    try {
      const response = await this.axios.get<FindProjectsResponse>(this.requestBasePath, { params: { 'organization-id': organizationId,'organizationId': organizationId } });
      return response.data.results
    } catch {
      // TODO: エラーハンドリング
    }
  }

  /** プロジェクト削除API */
  async deleteProject(organizationId: number, projectId: number) {
    const path = `${this.requestBasePath}/${projectId}`
    try {
      await this.axios.delete<void>(path, { params: { 'organization-id': organizationId } });
    } catch {
      // TODO: エラーハンドリング
    }
  }
}
